import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Organization, UpdateOrganizationRqDto } from 'src/app/Models/Organization/Organization';
import { OrganizationService } from '../services/organization.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-update-organization',
  templateUrl: './update-organization.component.html',
  styleUrls: ['./update-organization.component.scss'],
})
export class UpdateOrganizationComponent implements OnInit {

  public organization: Organization;
  public orgInformationForm: FormGroup = new FormGroup({
    Name: new FormControl(),
    Street: new FormControl(),
    Suburb: new FormControl(),
    City: new FormControl(),
    PostalCode: new FormControl(),
    PhoneNumber: new FormControl(),
    Email: new FormControl(),
    VAT: new FormControl(),
    TaxNumber: new FormControl(),
    RegNumber: new FormControl()
  });
  

  constructor(public modalController: ModalController, 
              private organizationService: OrganizationService,
              public authService: AuthService) { }

  ngOnInit() {
    this.getOrgData();
  }

  public async dismissModal() {
    this.modalController.dismiss();
  }

  public async updateOrg() {
    const formValue = this.orgInformationForm.value;

    const updateDto: UpdateOrganizationRqDto = {
      Id: this.authService.getActiveUser()?.OrganizationId || '',
      Owner: this.organization.Owner || '',
      LogoId: this.organization.LogoId || '',
      Name: formValue.Name || '',
      Street: formValue.Street || '',
      Suburb: formValue.Suburb || '',
      City: formValue.City || '',
      PostalCode: formValue.PostalCode || '',
      PhoneNumber: formValue.PhoneNumber || '',
      Email: formValue.Email || '',
      VATNumber: formValue.VAT || '',
      TaxNumber: formValue.TaxNumber || '',
      RegNumber: formValue.RegNumber || ''
    };

    console.log("This is the update dto", updateDto);
    await this.organizationService.updateOrganization(updateDto);
    await this.dismissModal();
  }

  //Get organisation details based on organisation Id
  private async getOrgData(): Promise<void> {
    this.organization = await this.organizationService.getOrganization({
      Id: this.authService.getActiveUser()?.OrganizationId,
    });


    // Ensure the organization data is retrieved and valid
    if (this.organization) {
      this.orgInformationForm.setValue({
        Name: this.organization.Name || '', 
        Street: this.organization.Street || '',
        Suburb: this.organization.Suburb || '',
        City: this.organization.City || '',
        PostalCode: this.organization.PostalCode || '',
        PhoneNumber: this.organization.PhoneNumber || '',
        Email: this.organization.Email || '',
        VAT: this.organization.VATNumber || '',
        TaxNumber: this.organization.TaxNumber || '',
        RegNumber: this.organization.RegNumber || ''
      });

    } else {
      // Future, add error handling
      console.error("No organization data found");
    }
  }

  //Update organisation values
  async onOrgValuesChange(event: any){
    const Vat_Number = event.detail.value;
    this.orgInformationForm.controls['VAT'].setValue(Vat_Number);
  }
  async onTaxValuesChange(event: any){
    const Taz_Number = event.detail.value;
    this.orgInformationForm.controls['TaxNumber'].setValue(Taz_Number);
  }
  async onRegValuesChange(event: any){
    const Reg_Number = event.detail.value;
    this.orgInformationForm.controls['RegNumber'].setValue(Reg_Number);
  }
  
}
